import CustomRouterUserConfirmation from './CustomRouterUserConfirmation';

export default CustomRouterUserConfirmation;
